exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-move, .cursor-move * {\n  cursor: move !important; }\n\n.cursor-default, .cursor-default * {\n  cursor: default !important; }\n\n.cursor-pointer, .cursor-pointer * {\n  cursor: pointer !important; }\n\n.cursor-col-resize, .cursor-col-resize * {\n  cursor: col-resize !important; }\n\n.cursor-row-resize, .cursor-row-resize * {\n  cursor: row-resize !important; }\n", ""]);

// exports
